<!-- @format -->
<div class="btn-group" role="group" aria-label="...">
   <button
      type="button"
      tooltip="Recent color"
      class="btn btn-default"
      [disabled]="disable"
      (click)="triggerSelectedFontChange()"
   >
      <i class="fa fa-font" [style.color]="selectedColor" aria-hidden="true"></i>
   </button>
   <p-overlayPanel #op styleClass="font-color__panel" [showCloseIcon]="true">
      <ng-template pTemplate>
         <p-colorPicker [(ngModel)]="pickedColor" [inline]="true"></p-colorPicker>
         Recent used:
         <div class="font_color__group">
            <span [style.backgroundColor]="selectedColor" class="font-color__square"></span>
            <span>{{ selectedColor }}</span>
         </div>
         Picked color:
         <div class="font_color__group">
            <span [style.backgroundColor]="pickedColor" class="font-color__square"></span>
            <input
               type="text"
               class="font-color__input"
               [(ngModel)]="pickedColor"
               [ngModelOptions]="{ standalone: true }"
            />
            <button
               type="button"
               class="btn btn-primary"
               tooltip="Apply picked color"
               (click)="op.hide(); triggerPickedFontChange()"
            >
               OK
            </button>
         </div>
      </ng-template>
   </p-overlayPanel>
   <button type="button" tooltip="More colors" class="btn btn-default" [disabled]="disable" (click)="op.toggle($event)">
      <i class="fa fa-tint" [style.color]="pickedColor" aria-hidden="true"></i>
   </button>
</div>
